<script setup lang="ts">
const props = defineProps<{
  href?: string
  arrowLeft?: boolean
  target?: string
}>()
</script>

<template>
  <NuxtLink
    :to="props?.href"
    :target="props?.target"
    class="flex flex-row gap-10 xl:gap-10 items-center group cursor-pointer"
  >
    <div
      v-if="props.arrowLeft"
      class="py-3 px-8 border border-Tekst rounded-full flex items-center justify-center group-hover:bg-Secondary group-hover:border-Secondary transition-all duration-300"
    >
      <i class="pi pi-arrow-left text-2xl! text-Tekst group-hover:text-white transition-all duration-300" />
    </div>
    <span class="text-Tekst group-hover:text-Secondary transition-all duration-300">
      <slot />
    </span>
    <div
      v-if="!props.arrowLeft"
      class="py-3 px-8 border border-Tekst rounded-full flex items-center justify-center group-hover:bg-Secondary group-hover:border-Secondary transition-all duration-300"
    >
      <i class="pi pi-arrow-right text-2xl! text-Tekst group-hover:text-white transition-all duration-300" />
    </div>
  </NuxtLink>
</template>
